import Button from "@/components/ui/Button";
import { cn } from "@/lib/utils";

interface Props {
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  submitButtonText?: string;
  submitButtonColor?: "yellow" | "blue" | "red";
  buttonClassName?: string;
}

const SubmitAndCancelButtons: React.FC<Props> = (
  {
    isLoading,
    onCancel,
    onSubmit,
    submitButtonText = "保存する",
    submitButtonColor = "yellow",
    buttonClassName = "",
  },
) => {
  const submitButtonStyles = {
    yellow: "",
    blue: "bg-[#6888E1] text-white border-[#6888E1] hover:bg-[#6888E1]/90 shadow-[0px_2px_#3C569D]",
    red: "bg-[#FF6B6B] text-white border-[#FF6B6B] hover:bg-[#FF6B6B]/90 shadow-[0px_2px_#9B3C44]",
  };

  return (
    <div data-testid="action-buttons" className="flex gap-2 justify-end">
      <Button
        className={cn(
          "w-auto h-10 px-4 py-2 !text-sm text-[#5F6368] !font-bold bg-white hover:bg-white hover:opacity-80",
          "border border-[#AAAAAA] shadow-[0px_2px_#828282]",
          buttonClassName,
        )}
        onClick={onCancel}
      >
        キャンセル
      </Button>
      <Button
        data-testid="submit-button"
        disabled={isLoading}
        onClick={onSubmit}
        className={cn(
          "w-auto h-10 px-4 py-2 !text-sm text-[#5F6368] !font-bold",
          submitButtonStyles[submitButtonColor],
          buttonClassName,
        )}
      >
        {submitButtonText}
      </Button>
    </div>
  );
};

export default SubmitAndCancelButtons;
